// reducer.js
import {
  SET_VALUE_ModeleReserv,
  SET_TYPE_ModeleReserv,
  SET_CURRENT_PAGE_ModeleReserv,
  SET_ORDER_ModeleReserv,
  SET_SORT_FIELD_ModeleReserv,
  SET_ACTIF_ModeleReserv,
  SET_CATEGORIE_ModeleReserv,
} from "./actionsTypes";

const initialState = {
  value: "",
  type: "",
  actif: "",
  currentPage: 1,
  order: "desc",
  sortField: "cree_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_ModeleReserv:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_ModeleReserv:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_TYPE_ModeleReserv:
      return {
        ...state,
        type: action.payload,
      };

    case SET_CURRENT_PAGE_ModeleReserv:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_ModeleReserv:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_ModeleReserv:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_ACTIF_ModeleReserv:
      return {
        ...state,
        actif: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
